











import { Component, Mixins } from 'vue-property-decorator'
import { Getter, State, namespace } from 'vuex-class'
import SurfaceOffline from 'vuecomponents/surface_offline.vue'
import SurfaceContainer from 'vuecomponents/surface_container.vue'
import AppGlobalSnackbar from 'vuecomponents/app_global_snackbar.vue'
import NativeAppMixin from 'vuemixins/native_app_mixin'
import GlobalStylesMixin from 'vuemixins/global_styles_mixin'
import PageStylingMixin from 'vuemixins/page_styling_mixin'
import FullscreenMixin from 'vuemixins/fullscreen_mixin'
import WindowSizeMixin from 'vuemixins/window_size_mixin'
import PresenceMixin from 'vuemixins/presence_mixin'
import DarkModeMixin from 'vuemixins/dark_mode_mixin'
import VisualViewportSizeMixin from 'vuemixins/visual_viewport_size_mixin'
import device from 'bits/device'

const mixins: any[] = [
  GlobalStylesMixin,
  PageStylingMixin,
  FullscreenMixin,
  WindowSizeMixin,
  PresenceMixin,
  DarkModeMixin,
  VisualViewportSizeMixin,
]
if (device.app) {
  mixins.push(NativeAppMixin)
}

@Component({
  components: {
    SurfaceOffline,
    SurfaceContainer,
    AppGlobalSnackbar,
    SurfaceAddPost: (): any => import('vuecomponents/surface_add_post.vue'),
    SurfacePanels: (): any => import('vuecomponents/surface_panels.vue'),
    SurfaceDragAndDropOverlay: (): any => import('vuecomponents/surface-drag-and-drop-overlay.vue'),
  },
})
export default class SurfaceApp extends Mixins(...mixins) {
  @State isOnline!: boolean
  @Getter isPostable!: boolean
  @Getter isUsingNewComposerModal!: boolean
  @(namespace('snackbars').Getter) xSnackbar!: boolean
}
